import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Iphone } from "../../Components/UI/iphone";
import video from "../../images/neytvideo.MP4";
import OrderForm from "../../Components/GetOrder/OrderForm";
import Footerls from "../../Components/footer/Footerls";
import { useMediaQuery } from "../../Constants/useMediaQuery";
const Getorder = () => {
  const [titleNumber, setTitleNumber] = useState(0);

  const titles = useMemo(
    () => [
      "დაბეჭდე",
      "შექმენი",
      //   "გააფორმე",
      //   "მოირგე",
      "შეუკვეთე",
    ],
    [],
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTitleNumber((prev) => (prev === titles.length - 1 ? 0 : prev + 1));
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);

  return (
    <div>
      <div className="relative flex h-[700px] bg-black max-h-screen w-full items-center justify-center overflow-hidden  shadow-2xl">
        <div className="flex flex-col gap-4  text-white">
          <motion.div
            initial={{ opacity: 0, filter: "blur(10px)", y: 20 }}
            animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
            transition={{
              duration: 0.9,
              delay: 0.3,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="flex flex-col gap-4 text-white"
          >
            <h1 className="max-w-2xl text-center font-normal tracking-tighter text-4xl ssxx:text-5xl ssm:text-6xl smm:text-7xl">
              <span className="text-spektr-cyan-50 font-Mtavruli">
                შენი დიზაინით
              </span>

              <span className="relative flex w-full justify-center overflow-hidden text-center md:pb-4 md:pt-1">
                &nbsp;
                {titles.map((title, index) => (
                  <motion.span
                    key={index}
                    className="absolute font-normal font-Mtavruli"
                    initial={{ opacity: 0, y: -100 }}
                    transition={{ type: "spring", stiffness: 50 }}
                    animate={
                      titleNumber === index
                        ? { y: 0, opacity: 1 }
                        : {
                            y: titleNumber > index ? -150 : 150,
                            opacity: 0,
                          }
                    }
                  >
                    {title}
                  </motion.span>
                ))}
              </span>
            </h1>

            {/* <p className="max-w-2xl text-center text-xs ssxx:text-sm ssm:text-lg leading-relaxed tracking-tight p-3 sm:p-0 text-muted-foreground md:text-xl">
              Managing a small business today is already tough...
            </p> */}
          </motion.div>
        </div>
      </div>

      <div className="w-full   ">
        <div className=" flex flex-row m-5 lg:m-10 gap-5 mmd:gap-12 clg:gap-20 xl:gap-28 cxl:gap-36  xxl:gap-52 justify-center items-center ">
          {/* <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 1,
              delay: 0.85,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="space-y-3 p-6"
          > */}
          <div className=" w-[360px] cxl:w-[434px] hidden mmd:block">
            <Iphone videoSrc={video} />
          </div>
          {/* </motion.div> */}

          {/* <motion.div
            initial={isMdUp ? { opacity: 0, x: 50 } : false}
            animate={isMdUp ? { opacity: 1, x: 0 } : { opacity: 1, x: -30 }}
            transition={{
              duration: 1,
              delay: 0.85,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="space-y-3 p-6"
          > */}
          <div>
            <OrderForm />
          </div>
          {/* </motion.div> */}
        </div>
      </div>
      <div>
        <Footerls />
      </div>
    </div>
  );
};

export default Getorder;
